import { defineComponent as _defineComponent } from 'vue'
import EprintQrCode from '@/components/format-edit/eprint/EprintQrCode.vue'
import EprintStoreMap from '@/components/format-edit/eprint/EprintStoreMap.vue'
import {
  useEprintActions,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'


export default /*#__PURE__*/_defineComponent({
  __name: 'EprintResultPanel',
  setup(__props) {

const session = useEprintSession()
const actions = useEprintActions()

function selectStore(store: string) {
  session.isQRCodeLoaded = false
  session.qrCodeError = false
  session.qrCodeRetryCount = 0
  session.selectedStore = store
}

return { __sfc: true,session, actions, selectStore, EprintQrCode, EprintStoreMap }
}

})